<template>
  <div class="text-dark box vacations-days__wrapper">
    <h1 v-if="isKindergarten">Lukkedage</h1><h1 v-else>{{ $t('vue.vacations_days_selector.vacation_for_pupils') }}</h1>
    <div class="flex">
      <div class="marg-20-right flex align-center">
        <span class="font-large" v-if="isKindergarten">Periode</span><span class="font-large" v-else>{{ $t('vue.vacations_days_selector.school_year') }} </span>
        <select class="marg-1-left like-date-picker" v-model="selectedSchoolYearIndex" v-on:change="onSchoolYearChanged">
          <option v-for="(schoolYear, index) in activeSchoolYears" :value="index">
            {{ schoolYear.name }}
          </option>
        </select>
      </div>
      <div class="marg-1-left marg-1-right">
        <date-picker-range
          @startchanged="onStartDateChanged"
          @endchanged="onEndDateChanged"
          :startdate="currFromDate"
          :enddate="currToDate"
          class="inline-block">
        </date-picker-range>
      </div>
      <div class="marg-20-right flex align-center pointer">
        <input id="weekendToggle" type="checkbox" class="pointer" v-model="includeWeekends" title="Include weekends">
        <label for="weekendToggle" class="marg-05-left pointer" style="font-weight: normal;">Include weekends</label>
      </div>
    </div>
    <div class="vacations-days-selector__year-calendar">
      <h2 class="marg-10-bottom"><template v-if="isKindergarten">Institutionen har åbent {{ schoolDaysCount }} dage</template><template v-else>{{ schoolDaysCount }} {{ $t('vue.vacations_days_selector.school_days') }}</template></h2>
      <direct-day-selector
        @toggled="dayToggled"
        :from-date="currFromDate"
        :to-date="currToDate"
        :selected-days="initialSelectedDates"
        :include-weekends="includeWeekends">
      </direct-day-selector>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DirectDaySelector from './DirectDaySelector'
import DatePickerRange from '../datepicker/DatePickerRange'
import docendo from '../../docendo'

export default {
  name: 'vacation-day-selector',
  components: {
    DirectDaySelector, DatePickerRange
  },
  props: {
    initialYear: {
      type: String,
      default: '2018-2019'
    },
    schoolId: {
      type: Number,
      default: 3
    },
    emitEventOnLoad: {
      type: Boolean,
      default: true
    },
    fromDate: {
      default () {
        return moment('2016-08-08T12:00')
      },
      validator (value) {
        return moment(value).isValid()
      }
    },
    toDate: {
      default () {
        return moment('2017-06-23T12:00')
      },
      validator (value) {
        return moment(value).isValid()
      }
    }
  },
  data () {
    return {
      initialSelectedDates: [],
      vacationDays: {},
      schoolYears: [],
      activeSchoolYears: [],
      selectedSchoolYearIndex: 0,
      currFromDate: this.fromDate,
      currToDate: this.toDate,
      includeWeekends: false
    }
  },
  watch: {
    schoolDaysCount (val) {
      this.$emit('schoolDays', val)
    }
  },
  // LIFECYCLE
  mounted () {
    docendo.schoolYearsRead(this.schoolId, {}, 'name', this.schoolYearsCallback)
    docendo.schoolVacationDaysRead(this.schoolId, this.initialDaysCallback)
  },
  computed: {
    schoolId () {
      if (window.SCHOOL && window.SCHOOL.id) {
        return window.SCHOOL.id
      }
      if (this.$route && this.$route.params && this.$route.params.school_id) {
        return this.$route.params.school_id
      }
    },
    isKindergarten () {
      return this.$store.getters.isKindergarten
    },
    vacationDaysBetweenStartAndEnd () {
      return this.initialSelectedDates.filter(date => {
        return moment(date).isSameOrBefore(this.currToDate) && moment(date).isSameOrAfter(this.currFromDate)
      })
    },
    vacationDaysWithoutWeekends () {
      return this.vacationDaysBetweenStartAndEnd.filter(date => {
        if (moment(date).isoWeekday() !== 6 && moment(date).isoWeekday() !== 7) {
          return date
        }
      })
    },
    allDates () {
      let startDate = this.currFromDate
      var dateArray = []
      var currentDate = moment(startDate)
      var stopDate = moment(this.currToDate)
      while (currentDate <= stopDate) {
        dateArray.push(moment(currentDate).format('YYYY-MM-DD'))
        currentDate = moment(currentDate).add(1, 'days')
      }
      return dateArray
    },
    weekends () {
      return this.allDates.filter(date => {
        if (moment(date).isoWeekday() === 6 || moment(date).isoWeekday() === 7) {
          return date
        }
      })
    },
    newCount () {
      return this.currToDate.diff(this.currFromDate, 'days') + 1
    },
    schoolDaysCount () {
      if (this.includeWeekends) {
        return this.newCount - this.vacationDaysBetweenStartAndEnd.length
      } else {
        return this.newCount - this.weekends.length - this.vacationDaysWithoutWeekends.length
      }
    },
    selectedSchoolYear () {
      return this.activeSchoolYears[this.selectedSchoolYearIndex]
    }
  },
  methods: {
    updateToFromDates () {
      this.currFromDate = moment(this.selectedSchoolYear.student_time_start)
      this.currToDate = moment(this.selectedSchoolYear.student_time_end)
    },
    dayToggled (date, isSelected) {
      if (isSelected) {
        docendo.schoolVacationDaysCreate(this.schoolId, date, this.saved, this.failed)
      } else {
        let id = this.vacationDays[date]
        docendo.schoolVacationDaysDelete(this.schoolId, id, this.saved, this.failed)
      }
    },
    saved (vacationDay) {
      this.vacationDays[vacationDay.day] = vacationDay.id
    },
    failed (error) {
      console.log('failed', error)
    },
    schoolYearsCallback (data) {
      this.schoolYears = data
      this.activeSchoolYears = this.schoolYears.filter(schoolYear => schoolYear.active)
      this.selectedSchoolYearIndex = this.initialYear ? this.activeSchoolYears.findIndex(x => x.name === this.initialYear) : 0
      if (this.selectedSchoolYearIndex < 0) {
        this.selectedSchoolYearIndex = 0
      }
      this.updateToFromDates()
    },
    initialDaysCallback (data) {
      this.initialSelectedDates = []
      data.forEach(function (vacationDay) {
        this.vacationDays[vacationDay.day] = vacationDay.id
        this.initialSelectedDates.push(vacationDay.day)
      }, this)
      if (this.emitEventOnLoad) {
        this.$store.dispatch('updateUserSettings', {'setup_widget_progress_vacation': true})
        // activate onboardArrow again
        setTimeout(() => {
          this.$store.commit('setOnboardingStep', 0)
        }, 2500)
      }
    },
    onSchoolYearChanged () {
      this.updateToFromDates()
      docendo.schoolVacationDaysRead(this.schoolId, this.initialDaysCallback)
    },
    onStartDateChanged (date) {
      let self = this
      if (this.selectedSchoolYear === undefined) {
        return
      }
      if (date !== this.selectedSchoolYear.student_time_start) {
        docendo.schoolYearsUpdate(
          this.schoolId,
          this.selectedSchoolYear.id,
          {student_time_start: date},
          function (data) {
            // self.selectedSchoolYear = data
            self.currFromDate = moment(date)
            self.schoolYears[self.selectedSchoolYearIndex].student_time_start = data.student_time_start
          }
        )
      }
    },
    onEndDateChanged (date) {
      let self = this
      if (this.selectedSchoolYear === undefined) {
        return
      }
      if (date !== this.selectedSchoolYear.student_time_end) {
        docendo.schoolYearsUpdate(
          this.schoolId,
          this.selectedSchoolYear.id,
          {student_time_end: date},
          function (data) {
            // self.selectedSchoolYear = data
            self.currToDate = moment(date)
            self.schoolYears[self.selectedSchoolYearIndex].student_time_end = data.student_time_end
          }
        )
      }
    }
  }
}
</script>

<style scoped>

.vacations-days__wrapper {
  margin: 20px;
  transition: margin .2s ease-in-out;
}

#djs-content-container.djs_setup_widget_open .vacations-days__wrapper {
  margin-right: 340px; /* setup wigidget width is 320px */
}

.vacations-days-selector__year-calendar {
  margin-top: 40px;
}

.like-date-picker {
  height: 38px;
  background-color: white;
  border: 1px solid #acb6be;
  display: inline-block;
}

.marg-05-left {
  margin-left: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// VacationDaysSelector.vue?a05523fa